// Generated by scripts/generate-registry.mjs. Do not edit directly.
export const STATUS_DEFINITIONS = [
    {
        code: 100,
        name: 'CONTINUE',
        message: 'Continue',
    },
    {
        code: 101,
        name: 'SWITCHING_PROTOCOLS',
        message: 'Switching Protocols',
    },
    {
        code: 102,
        name: 'PROCESSING',
        message: 'Processing',
    },
    {
        code: 103,
        name: 'EARLY_HINTS',
        message: 'Early Hints',
    },
    {
        code: 104,
        name: 'UPLOAD_RESUMPTION_SUPPORTED',
        message: 'Upload Resumption Supported',
    },
    {
        code: 200,
        name: 'OK',
        message: 'OK',
    },
    {
        code: 201,
        name: 'CREATED',
        message: 'Created',
    },
    {
        code: 202,
        name: 'ACCEPTED',
        message: 'Accepted',
    },
    {
        code: 203,
        name: 'NON_AUTHORITATIVE_INFORMATION',
        message: 'Non-Authoritative Information',
    },
    {
        code: 204,
        name: 'NO_CONTENT',
        message: 'No Content',
    },
    {
        code: 205,
        name: 'RESET_CONTENT',
        message: 'Reset Content',
    },
    {
        code: 206,
        name: 'PARTIAL_CONTENT',
        message: 'Partial Content',
    },
    {
        code: 207,
        name: 'MULTI_STATUS',
        message: 'Multi-Status',
    },
    {
        code: 208,
        name: 'ALREADY_REPORTED',
        message: 'Already Reported',
    },
    {
        code: 226,
        name: 'IM_USED',
        message: 'IM Used',
    },
    {
        code: 300,
        name: 'MULTIPLE_CHOICES',
        message: 'Multiple Choices',
    },
    {
        code: 301,
        name: 'MOVED_PERMANENTLY',
        message: 'Moved Permanently',
    },
    {
        code: 302,
        name: 'FOUND',
        message: 'Found',
    },
    {
        code: 303,
        name: 'SEE_OTHER',
        message: 'See Other',
    },
    {
        code: 304,
        name: 'NOT_MODIFIED',
        message: 'Not Modified',
    },
    {
        code: 305,
        name: 'USE_PROXY',
        message: 'Use Proxy',
    },
    {
        code: 306,
        name: 'UNUSED',
        message: 'Unused',
    },
    {
        code: 307,
        name: 'TEMPORARY_REDIRECT',
        message: 'Temporary Redirect',
    },
    {
        code: 308,
        name: 'PERMANENT_REDIRECT',
        message: 'Permanent Redirect',
    },
    {
        code: 400,
        name: 'BAD_REQUEST',
        message: 'Bad Request',
    },
    {
        code: 401,
        name: 'UNAUTHORIZED',
        message: 'Unauthorized',
    },
    {
        code: 402,
        name: 'PAYMENT_REQUIRED',
        message: 'Payment Required',
    },
    {
        code: 403,
        name: 'FORBIDDEN',
        message: 'Forbidden',
    },
    {
        code: 404,
        name: 'NOT_FOUND',
        message: 'Not Found',
    },
    {
        code: 405,
        name: 'METHOD_NOT_ALLOWED',
        message: 'Method Not Allowed',
    },
    {
        code: 406,
        name: 'NOT_ACCEPTABLE',
        message: 'Not Acceptable',
    },
    {
        code: 407,
        name: 'PROXY_AUTHENTICATION_REQUIRED',
        message: 'Proxy Authentication Required',
    },
    {
        code: 408,
        name: 'REQUEST_TIMEOUT',
        message: 'Request Timeout',
    },
    {
        code: 409,
        name: 'CONFLICT',
        message: 'Conflict',
    },
    {
        code: 410,
        name: 'GONE',
        message: 'Gone',
    },
    {
        code: 411,
        name: 'LENGTH_REQUIRED',
        message: 'Length Required',
    },
    {
        code: 412,
        name: 'PRECONDITION_FAILED',
        message: 'Precondition Failed',
    },
    {
        code: 413,
        name: 'CONTENT_TOO_LARGE',
        message: 'Content Too Large',
    },
    {
        code: 414,
        name: 'URI_TOO_LONG',
        message: 'URI Too Long',
    },
    {
        code: 415,
        name: 'UNSUPPORTED_MEDIA_TYPE',
        message: 'Unsupported Media Type',
    },
    {
        code: 416,
        name: 'RANGE_NOT_SATISFIABLE',
        message: 'Range Not Satisfiable',
    },
    {
        code: 417,
        name: 'EXPECTATION_FAILED',
        message: 'Expectation Failed',
    },
    {
        code: 418,
        name: 'IM_A_TEAPOT',
        message: "I'm a teapot",
    },
    {
        code: 421,
        name: 'MISDIRECTED_REQUEST',
        message: 'Misdirected Request',
    },
    {
        code: 422,
        name: 'UNPROCESSABLE_CONTENT',
        message: 'Unprocessable Content',
    },
    {
        code: 423,
        name: 'LOCKED',
        message: 'Locked',
    },
    {
        code: 424,
        name: 'FAILED_DEPENDENCY',
        message: 'Failed Dependency',
    },
    {
        code: 425,
        name: 'TOO_EARLY',
        message: 'Too Early',
    },
    {
        code: 426,
        name: 'UPGRADE_REQUIRED',
        message: 'Upgrade Required',
    },
    {
        code: 428,
        name: 'PRECONDITION_REQUIRED',
        message: 'Precondition Required',
    },
    {
        code: 429,
        name: 'TOO_MANY_REQUESTS',
        message: 'Too Many Requests',
    },
    {
        code: 431,
        name: 'REQUEST_HEADER_FIELDS_TOO_LARGE',
        message: 'Request Header Fields Too Large',
    },
    {
        code: 451,
        name: 'UNAVAILABLE_FOR_LEGAL_REASONS',
        message: 'Unavailable For Legal Reasons',
    },
    {
        code: 500,
        name: 'INTERNAL_SERVER_ERROR',
        message: 'Internal Server Error',
    },
    {
        code: 501,
        name: 'NOT_IMPLEMENTED',
        message: 'Not Implemented',
    },
    {
        code: 502,
        name: 'BAD_GATEWAY',
        message: 'Bad Gateway',
    },
    {
        code: 503,
        name: 'SERVICE_UNAVAILABLE',
        message: 'Service Unavailable',
    },
    {
        code: 504,
        name: 'GATEWAY_TIMEOUT',
        message: 'Gateway Timeout',
    },
    {
        code: 505,
        name: 'HTTP_VERSION_NOT_SUPPORTED',
        message: 'HTTP Version Not Supported',
    },
    {
        code: 506,
        name: 'VARIANT_ALSO_NEGOTIATES',
        message: 'Variant Also Negotiates',
    },
    {
        code: 507,
        name: 'INSUFFICIENT_STORAGE',
        message: 'Insufficient Storage',
    },
    {
        code: 508,
        name: 'LOOP_DETECTED',
        message: 'Loop Detected',
    },
    {
        code: 510,
        name: 'NOT_EXTENDED',
        message: 'Not Extended',
    },
    {
        code: 511,
        name: 'NETWORK_AUTHENTICATION_REQUIRED',
        message: 'Network Authentication Required',
    },
] as const;
